import React from 'react';

import '../styles/listAdvantages.scss'

export default class ListAdvantages extends React.Component{
    render(){
        return(
            <>
                <div id="wrap-list-advantages">
                    <img id="list-advantages" src="./assets/images/homePage/homePage-listAdvantage.jpg" alt="list advantages"/>
                </div>
            </>
        )
    }
}